import PurchaseResultContent from './component';

export default PurchaseResultContent;
